<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card" style="margin-top: 3px">
      <div slot="header" class="clearfix">
        <span>充值返利区间</span>
        <el-button
          style="float: right"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog(true, null)"
          >新增返利区间</el-button
        >
      </div>
      <el-form-item label-width="90px" label="返利道具：" prop="rewardID">
        <el-select v-model="data.rewardID" filterable placeholder="道具">
          <el-option
            v-for="(item, key) in attachments"
            :key="key + $util.uuid()"
            :label="item"
            :value="parseInt(key)"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="90px" label="返利汇率：" prop="exchangeRate">
        <el-input
          style="width: 120px"
          type="nubmer"
          v-model.number="data.exchangeRate"
          onkeyup="value=value.replace(/[^\d]/g, '')"
        ></el-input>
      </el-form-item>
      <el-table
        :data="data.rewardRanges"
        border
        size="small"
        style="width: 491px; margin-top: 10px"
      >
        <el-table-column
          prop="range"
          label="返利区间(元)"
          align="center"
          width="200"
        >
          <template scope="scope">
            {{ `${scope.row.range[0]} - ${scope.row.range[1]}` }}
          </template>
        </el-table-column>
        <el-table-column
          prop="rebateRatio"
          label="返利倍率"
          align="center"
          width="150"
        >
          <template scope="scope">
            {{ scope.row.rebateRatio }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="140">
          <template slot-scope="scope">
            <span
              class="link-button"
              style="color: red"
              @click="remove(scope.$index)"
              >删除</span
            >
            <span
              class="link-button"
              @click="openDialog(false, scope.row, scope.$index)"
              >编辑</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import ShowItems from "./components/ShowItems";
export default {
  data() {
    return {
      data: {
        rewardRanges: [],
      },
      attachments: {},
    };
  },
  components: {
    ShowItems,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
    this.attachments = await this.$bizutil.loadAttachments(false);
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {},
    async openDialog(isCreated, entry, index) {
      let that = this;
      this.$dialogutil.open("EditRechargeRebateDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            if (isCreated) {
              that.data.rewardRanges.push(param);
            } else {
              this.$set(that.data.rewardRanges, index, param);
            }

            this.data.rewardRanges.sort((x, y) => {
              return x.range[0] - y.range[0];
            });

            await this.updatedParam();
          }
        },
        data: { isCreated, entry },
      });
    },
    async remove(index) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除返利区间[${this.data.rewardRanges[index].range}]的配置？`
        );
        this.data.rewardRanges.splice(index, 1);

        await this.updatedParam();
      } catch (error) {}
    },

    async updatedParam() {
      this.$emit("updated", JSON.stringify(this.data), async () => {
        for (let index = 0; index < this.data.rewardRanges.length; index++) {
          if (index == 0) {
            continue;
          }
          let entry = this.data.rewardRanges[index];
          let preEntry = this.data.rewardRanges[index - 1];
          if (entry.range[0] - preEntry.range[1] != 1) {
            return { errMsg: "各个返利区间必须前后衔接" };
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

/deep/ .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>